import { render, staticRenderFns } from "./PetConfig.vue?vue&type=template&id=31b41114&scoped=true"
import script from "./PetConfig.vue?vue&type=script&lang=js"
export * from "./PetConfig.vue?vue&type=script&lang=js"
import style0 from "./PetConfig.vue?vue&type=style&index=0&id=31b41114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b41114",
  null
  
)

export default component.exports